module.exports = __webpack_public_path__ + "assets/icons/logo-auction-blue-fd73.svg";